import React, { useState, useEffect } from 'react';
import { useFeriadosLazyQuery } from '../graphql/queries/feriados.query';
import { FeriadosPageQuery_feriados } from '../graphql/queries/__generated__/FeriadosPageQuery';
import { useCadastrarFeriadoMutation } from '../graphql/mutations/cadastrar_feriado.mutation';
import { useDeletarFeriadoMutation } from '../graphql/mutations/deletar_feriado.mutation';
import { useEditarFeriadoMutation } from '../graphql/mutations/editar_feriado.mutation';
import { FormFeriado, FormularioFeriado } from '../components/form_feriado';
import { FormList } from '../../shared/components/form_components/list';
import { Container } from '../../shared/components/layout_components/container/styles';
import { DateTime } from 'luxon';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';

const FeriadoPage: React.FC = () => {
  const [feriado, setFeriado] = useState<FormFeriado>();
  const [feriados, setFeriados] = useState<FeriadosPageQuery_feriados[]>([]);
  const [termoBusca, setTermoBusca] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itens_por_pagina = 25;

  const [obter_feriados, { fetchMore, loading }] = useFeriadosLazyQuery();
  const [cadastar_feriado] = useCadastrarFeriadoMutation();
  const [editar_feriado] = useEditarFeriadoMutation();
  const [deletar_feriado] = useDeletarFeriadoMutation();

  const on_submit = async (feriado: FormFeriado) => {
    if (!feriado.id_feriado) {
      const { data } = await cadastar_feriado({
        variables: {
          ...feriado,
        },
      });

      if (data) {
        setFeriados([...feriados, data.cadastrarFeriado]);

        alert('Feriado cadastrado com sucesso!');
      }
    } else {
      const { data } = await editar_feriado({
        variables: {
          ...feriado,
          id_feriado: feriado.id_feriado,
        },
      });

      if (data) {
        const index = feriados.findIndex(
          (feriado) => feriado.id_feriado === data.editarFeriado.id_feriado
        );

        if (index !== -1) {
          const feriados_atualizados = [...feriados];
          feriados_atualizados[index] = data.editarFeriado;
          setFeriados(feriados_atualizados);
        }

        alert('Feriado editado com sucesso!');
      }
    }

    setFeriado(undefined);
  };

  const on_edit = (feriado: FeriadosPageQuery_feriados) => {
    setFeriado({
      id_feriado: feriado.id_feriado,
      dat_feriado: DateTime.fromISO(feriado.dat_feriado, { setZone: true }).toFormat('yyyy-MM-dd'),
      dsc_feriado: feriado.dsc_feriado || '',
    });
  };

  const on_delete = async (id_feriado: number) => {
    await deletar_feriado({ variables: { id_feriado } });
    setFeriados((feriados) => feriados.filter((f) => f.id_feriado !== id_feriado));
  };

  const on_cancel_edit = () => {
    setFeriado(undefined);
  };

  const obter_mais_dados = async (descricao = '', pagina = 1) => {
    const { data } = await fetchMore({
      variables: {
        descricao,
        pagina,
        itens_por_pagina,
      },
    });

    if (data && pagina > 1) {
      setFeriados([...feriados, ...data.feriados]);
    } else {
      setFeriados(data.feriados);
    }
  };

  const dados_dados_iniciais = async () => {
    const { data } = await obter_feriados({
      variables: {
        descricao: '',
        pagina: 1,
        itens_por_pagina,
      },
    });

    if (data) {
      setFeriados(data.feriados);
    }
  };

  const proxima_pagina = () => {
    setPaginaAtual((paginaAtual) => paginaAtual + 1);
  };

  useEffect(() => {
    obter_mais_dados(termoBusca);
  }, [termoBusca]);

  useEffect(() => {
    obter_mais_dados(termoBusca, paginaAtual);
  }, [paginaAtual]);

  useEffect(() => {
    document.title = 'SisIEC - Feriados';
    dados_dados_iniciais();
  }, []);

  return (
    <Container>
      <SubContainer flex={1}>
        <FormularioFeriado onSubmit={on_submit} onCancel={on_cancel_edit} feriado={feriado} />
      </SubContainer>

      <SubContainer flex={2}>
        <FormList
          list_name='Feriados'
          items={feriados.map((f) => ({
            data: f,
            id: f.id_feriado,
            label:
              DateTime.fromISO(f.dat_feriado, { setZone: true }).toFormat('dd/MM/yyyy') +
              ' - ' +
              (f.dsc_feriado || ''),
          }))}
          onSearch={setTermoBusca}
          onScroll={proxima_pagina}
          onEdit={on_edit}
          onDelete={on_delete}
          loading={loading}
        />
      </SubContainer>
    </Container>
  );
};

export { FeriadoPage };
